<div class="flex flex-column gap pt-3">
    <div class="flex flex-wrap gap">

        <app-text-input id="name" [form]="form" [prefix]="prefix"></app-text-input>
        <app-select-input id="code" [form]="form" [prefix]="prefix" [staticOptions]="codes"></app-select-input>

        <app-select-input id="unit" [form]="form" [staticOptions]="availableUnits()"
            [prefix]="prefix" class="midLabel"></app-select-input>

        <app-text-input
            id="winCarolCode" [form]="form" [disabled]="true" [prefix]="prefix"
            [pTooltip]="'serviceType.labels.winCarolCode' | translate"
        ></app-text-input>
        <app-text-input id="customCode" [form]="form" [prefix]="prefix"></app-text-input>

        <app-check-input id="payment" [form]="form" [prefix]="prefix"></app-check-input>
        <app-text-input id="maxPrice" [form]="form" [prefix]="prefix" class="midLabel"></app-text-input>
        <app-text-input id="maxPriceExt" [form]="form" [prefix]="prefix" class="longLabel"></app-text-input>

        <app-date-input id="validFrom" [form]="form" [prefix]="prefix" timeType="startOfDay"></app-date-input>
        <app-date-input id="validTo" [form]="form" [prefix]="prefix" timeType="endOfDay"></app-date-input>

    </div>

    <app-text-area-input id="description" [form]="form" [label]="prefix + 'fields.description'"></app-text-area-input>
</div>
